require("./ComplexityAlert.scss");

const React = require("react");
const { FormattedText } = require("core/i18n").i18n;

const comlexity_icon = require("../../assets/images/complexity_icon.svg");
const security_icon = require("../../assets/images/security_icon.svg");

class ComplexityAlert extends React.Component {
    render() {
        return (
            <div className="alertComplexity">
                <div className="section">
                    <FormattedText
                        value="brokerAlternativeFundsCard-alertComplexity_title"
                        className="section--title"
                    />
                    <div className="section--itemsContainer">
                        <div className="section--item">
                            <div className="section--iconContainer">
                                <img
                                    src={comlexity_icon}
                                    alt="complexity icon"
                                />
                            </div>
                            <FormattedText
                                value="brokerAlternativeFundsCard-alertComplexity_content"
                                className="section--textContent"
                            />
                        </div>
                    </div>
                </div>

                <div className="section">
                    <FormattedText
                        value="brokerAlternativeFundsCard-alertComplexity_title_second"
                        className="section--title"
                    />
                    <div className="section--itemsContainer">
                        <div className="section--item">
                            <div className="section--iconContainer">
                                <img src={security_icon} alt="security icon" />
                                <img src={security_icon} alt="security icon" />
                            </div>
                            <FormattedText
                                value="brokerAlternativeFundsCard-alertComplexity_content_one"
                                className="section--textContent"
                            />
                        </div>

                        <div className="section--item">
                            <div className="section--iconContainer">
                                <img src={security_icon} alt="security icon" />
                                <img src={security_icon} alt="security icon" />
                            </div>
                            <FormattedText
                                value="brokerAlternativeFundsCard-alertComplexity_content_second"
                                className="section--textContent"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports = ComplexityAlert ;
